import createModel, { defineModel } from '~/lib/model';
import type { Model, ModelDefinition } from '~/typings/model';
import type { StatusAnnouncement } from '~/models/StatusAnnouncement';
import type { User } from '~/models/User';

export interface StatusFeedback extends Model {
    uuid: string;
    announcement: StatusAnnouncement;
    user: User | null;
    feedback: string;
    sentry_id: string | null;
}

const statusFeedbackModelType = createModel(
    'status-feedback',
    defineModel<StatusFeedback>(''),
    {},
);

const useStatusFeedback = (announcementUuid?: string): ModelDefinition<typeof statusFeedbackModelType> => {
    const statusFeedbackModel = createModel(
        announcementUuid ? `status-feedback-${announcementUuid}` : 'status-feedback',
        defineModel<StatusFeedback>(
            announcementUuid
            ? `status/announcements/${announcementUuid}/feedback`
            : 'status/announcements/feedback',
        ),
        {},
    );

    return statusFeedbackModel();
};

export default useStatusFeedback;
